/** @jsx jsx */
import PropTypes from "prop-types"
import { Grid, jsx } from "theme-ui"

import RichText from "@components/RichText"

import CtaLink from "./CtaLink"
import ImageLink from "@components/ImageLink"
import ListItem from "./ListItem"
import ListTitle from "./ListTitle"
import Subtitle from "./Subtitle"

export default function List({
  link,
  list,
  listTitle,
  subtitle,
  text,
  title,
  appStoreLinks,
}) {
  return (
    <Grid
      as="article"
      gap={11}
      sx={{ alignContent: "center", minWidth: [null, null, 450] }}
    >
      {title ? <Subtitle>{title}</Subtitle> : null}
      {text?.json ? <RichText json={text.json} /> : null}
      {listTitle ? <ListTitle>{listTitle}</ListTitle> : null}
      <Grid gap={20} as="menu" sx={{ paddingLeft: 0 }}>
        {list.map(listItem =>
          listItem.__typename === "ContentfulIconListItem" ? (
            <ListItem key={listItem.id} {...listItem} />
          ) : (
            <Grid
              as="li"
              columns="20px 1fr"
              key={listItem.id}
              sx={{
                gap: 6,
                alignItems: "center",
              }}
            >
              <img
                alt="bullet"
                aria-hidden="true"
                src="/imgs/brocc.svg"
                sx={{
                  width: "25px",
                  height: "25px",
                  color: "green",
                }}
              />
              <span sx={{ fontSize: 2, color: "black", fontWeight: "medium" }}>
                {listItem.simpleText}
              </span>
            </Grid>
          )
        )}
      </Grid>
      {link ? (
        <CtaLink href={link.href} to={link.slug}>
          {link.title}
        </CtaLink>
      ) : null}

      {appStoreLinks && (
        <div
          sx={{
            display: "flex",
            gap: 4,
          }}
        >
          {appStoreLinks.map(link => (
            <ImageLink
              key={link.url}
              url={link.url}
              imageUrl={link.image.file.url}
              altText={link.altText}
            />
          ))}
        </div>
      )}
    </Grid>
  )
}

List.defaultProps = {
  link: null,
  listTitle: undefined,
  subtitle: undefined,
  text: null,
}

List.propTypes = {
  link: PropTypes.shape({
    href: PropTypes.string,
    slug: PropTypes.string,
    title: PropTypes.string.isRequired,
  }),
  list: PropTypes.arrayOf(PropTypes.shape(ListItem.propTypes)).isRequired,
  listTitle: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.shape({
    json: PropTypes.object.isRequired,
  }),
  title: PropTypes.string.isRequired,
}
